import { getUserInfoApi } from 'src/api/common'
export default {
  namespaced: true,
  state: {
    userInfo: null,
  },

  mutations: {
    SET_INFO: (state, info) => {
      state.userInfo = info || null
    },
  },

  actions: {
    async getUserInfo ({ state, commit }) {
      try {
        let userInfo = null
        if (!state.userInfo) {
          userInfo = await getUserInfoApi()
          commit('SET_INFO', userInfo)
        }
      } catch (e) {
        return Promise.reject(e)
      }
    },
  },
}
